import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './Icon';

const LINKS = [
    { label: 'Главная',   path: '/',           match: (p) => p === '/' },
    { label: 'Категории', path: '/categories', match: (p) => p.startsWith('/categories') },
    { label: 'Комментарии', path: '/comments', match: (p) => p.startsWith('/comments') },
];

export default function DesktopNav() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <div className="hb-desktop-nav">
            <div className="hb-desktop-nav__inner">
                {/* Logo */}
                <a
                    href="/"
                    onClick={(e) => { e.preventDefault(); navigate('/'); }}
                    style={{
                        textDecoration: 'none', padding: '0 4px',
                        fontSize: 17, fontWeight: 800, letterSpacing: -0.4,
                        color: '#e60073', flexShrink: 0,
                        fontFamily: "'Manrope', sans-serif",
                    }}
                >
                    Hentai<span style={{ color: '#fff' }}>Baza</span>
                </a>

                {/* Nav links */}
                <nav style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                    {LINKS.map(l => {
                        const active = l.match(pathname);
                        return (
                            <a
                                key={l.path}
                                href={l.path}
                                onClick={(e) => { e.preventDefault(); navigate(l.path); }}
                                style={{
                                    background: active ? '#17171A' : 'transparent',
                                    border: `1px solid ${active ? '#27272A' : 'transparent'}`,
                                    borderRadius: 8, padding: '6px 14px',
                                    color: active ? '#fff' : '#A1A1AA',
                                    fontSize: 13, fontWeight: 600, cursor: 'pointer',
                                    textDecoration: 'none',
                                    fontFamily: "'Manrope', sans-serif",
                                    transition: 'color 120ms, background 120ms',
                                }}
                                onMouseEnter={e => { if (!active) e.currentTarget.style.color = '#fff'; }}
                                onMouseLeave={e => { if (!active) e.currentTarget.style.color = '#A1A1AA'; }}
                            >
                                {l.label}
                            </a>
                        );
                    })}
                    <a
                        href="https://theporndude.com/ru"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        style={{
                            background: 'transparent',
                            border: '1px solid transparent',
                            borderRadius: 8, padding: '6px 14px',
                            color: '#A1A1AA',
                            fontSize: 13, fontWeight: 600,
                            textDecoration: 'none',
                            fontFamily: "'Manrope', sans-serif",
                            transition: 'color 120ms',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.color = '#fff'; }}
                        onMouseLeave={e => { e.currentTarget.style.color = '#A1A1AA'; }}
                    >
                        ThePornDude
                    </a>
                </nav>

                {/* Right actions */}
                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                    <a href="/search" aria-label="Поиск" onClick={(e) => { e.preventDefault(); navigate('/search'); }} style={{
                        background: 'transparent', border: 0, padding: 8,
                        cursor: 'pointer', display: 'flex', borderRadius: 8,
                    }}>
                        <Icon name="search" size={19} color="#A1A1AA" />
                    </a>
                    <a href="/profile" aria-label="Профиль" onClick={(e) => { e.preventDefault(); navigate('/profile'); }} style={{
                        background: 'transparent', border: 0, padding: 8,
                        cursor: 'pointer', display: 'flex', borderRadius: 8,
                    }}>
                        <Icon name="user" size={19} color="#A1A1AA" />
                    </a>
                </div>
            </div>
        </div>
    );
}
